import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: Number }

  connect() {
    if (this.hasDelayValue) {
      this.autoClose()
    }
  }

  close() {
    this.element.style.transition = "opacity 0.3s ease-out"
    this.element.style.opacity = "0"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  autoClose() {
    setTimeout(() => {
      this.close()
    }, this.delayValue)
  }
}
